<template>
    <div>
        <el-tabs type="border-card">
            <!-- <el-tab-pane label="内部备注">
        <el-row>
          <el-col :span="24">
            <div style="overflow: hidden;line-height: 40px;" class="border-bottom">
              <div style="float: left;">
                <span style="color: red;">公司简称(姓名)：</span>我我我
                <el-image
                  style="width: 20px; height: 20px;float: right;padding-left: 10px;;padding-top: 6px"
                  :src="url"
                  :preview-src-list="srcList"
                ></el-image>
              </div>
              <div style="float: right;">
                <span style="color: #0072ff;" @click="Handle">处理：</span>2019.12.26
              </div>
            </div>
            <div style="overflow: hidden;" class="margin-top2">
              <div style="float: left;width: 65%;border-radius: 2px;border:1px #eee solid;">
                <el-upload
                  action="https://jsonplaceholder.typicode.com/posts/"
                  list-type="picture-card"
                  :on-preview="handlePictureCardPreview"
                  :on-remove="handleRemove"
                >
                  <i class="el-icon-plus" style="color: #0724ef;"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible" append-to-body>
                  <img width="100%" :src="dialogImageUrl" alt />
                </el-dialog>
                <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="textarea"></el-input>
              </div>
              <div style="float: right; width: 30%;">
                <el-select v-model="surplusprofitValue" placeholder="请选择">
                  <el-option
                    v-for="item in goodslist"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-button style="margin-top:15%;" type="primary" @click="Preservation">保存</el-button>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="库房备注">
        <el-row>
          <el-col :span="24">
            <div style="overflow: hidden;line-height: 40px;" class="border-bottom">
              <div style="float: left;">
                <span style="color: red;">公司简称(姓名)：</span>我我我
                <el-image
                  style="width: 20px; height: 20px;float: right;padding-left: 10px;;padding-top: 6px"
                  :src="url"
                  :preview-src-list="srcList"
                ></el-image>
              </div>
              <div style="float: right;">
                <span style="color: #0072ff;" @click="Handle">处理：</span>2019.12.26
              </div>
            </div>
            <div style="overflow: hidden;" class="margin-top2">
              <div style="float: left;width: 65%;border-radius: 2px;border:1px #eee solid;">
                <el-upload
                  action="https://jsonplaceholder.typicode.com/posts/"
                  list-type="picture-card"
                  :on-preview="handlePictureCardPreview"
                  :on-remove="handleRemove"
                >
                  <i class="el-icon-plus" style="color: #0724ef;"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible" append-to-body>
                  <img width="100%" :src="dialogImageUrl" alt />
                </el-dialog>
                <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="textarea"></el-input>
              </div>
              <div style="float: right; width: 30%;">
                <el-select v-model="surplusprofitValue" placeholder="请选择">
                  <el-option
                    v-for="item in goodslist"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-button style="margin-top:15%;" type="primary" @click="Preservation">保存</el-button>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-tab-pane> -->
            <el-tab-pane label="操作日志">
              1111
                <!-- <div style="overflow: hidden;line-height: 40px;" class="border-bottom">
                    <div style="float: left;">
                        <span style="color: red;">部门(姓名)：</span>
                        我我我
                    </div>
                    <div style="float: right;">
                        <span style="color: #0072ff;">处理：</span>
                        2019.12.26
                    </div>
                </div> -->
            </el-tab-pane>
        </el-tabs>
        <!-- 处理 -->
        <el-dialog title="处理" :visible.sync="dialogTableVisible" append-to-body>
            <div style="border-radius: 2px;border:1px #eee solid;">
                <el-upload action="#" list-type="picture-card" :auto-upload="false" style="padding: 0 10px;">
                    <div class="addiconde">
                        <i slot="default" class="el-icon-plus" style="color: #0724ef;"></i>
                    </div>
                    <div slot="file" slot-scope="{ file }" style="width: 48px;height: 48px;">
                        <img class="el-upload-list__item-thumbnail" :src="file.url" alt />
                    </div>
                </el-upload>
                <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="Handleinput"></el-input>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogTableVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogTableVisible = false">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: "Remarks",
    data() {
        return {
            dialogTableVisible: false,
            dialogImageUrl: "",
            textarea: "",
            dialogVisible: false,
            Handleinput: "",
            url: require("../../assets/imags/picture.png"),
            surplusprofitValue: "",
            goodslist: "",
            srcList: [
                "https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg",
                "https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg",
            ],
        };
    },
    mounted() {},
    created() {},
    methods: {
        Handle() {
            this.dialogTableVisible = true;
        },
        handleRemove(file) {
            console.log(file);
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        Preservation() {},
    },
};
</script>
<style lang="scss" scoped>
/deep/ {
    .el-carousel__container {
        position: relative;
        height: 204px;
    }
    .el-carousel__indicators--horizontal {
        display: none;
    }
    .el-textarea__inner:focus {
        outline: 0;
        border-color: #fff;
    }
    .el-textarea__inner {
        border: 1px solid #fff;
    }
    .el-input-group__prepend {
        padding: 0 2px;
        text-align: center;
    }
    .el-form-item__label {
        text-align: center;
    }
}
</style>
